import configs from "./config";

// Публичная конфигурация с бэкенда (кэшируется в localStorage).
// isEmailEnabled() — включена ли почта; при выключенной прячем почтовые функции.
export const isEmailEnabled = () =>
  localStorage.getItem("csi_email_enabled") === "true";

export const loadAppConfig = () =>
  fetch(configs.BASE_URL_AUTO + "/users/app_config/")
    .then((r) => r.json())
    .then((d) =>
      localStorage.setItem(
        "csi_email_enabled",
        d && d.email_enabled ? "true" : "false"
      )
    )
    .catch(() => {});
